var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "Firmware-version" },
    [
      _c("pageTitle", _vm._b({}, "pageTitle", { ..._vm.pT }, false)),
      _c(
        "business-group",
        {
          ref: "businessGroup",
          attrs: {
            tableConfig: { ..._vm.tableConfig },
            formConfig: { ..._vm.formConfig },
          },
          scopedSlots: _vm._u([
            {
              key: "formSlot",
              fn: function (formSlot) {
                return [
                  _c(
                    "a-form-item",
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["type"],
                              expression: "['type']",
                            },
                          ],
                          staticStyle: { width: "200px" },
                          attrs: { placeholder: "请选择FAQ类型" },
                        },
                        _vm._l(_vm.faqTypes, function (value, key) {
                          return _c(
                            "a-select-option",
                            { key: key, attrs: { value: key } },
                            [_vm._v(_vm._s(value))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "a-form-item",
                    [
                      _c("a-input", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["title"],
                            expression: "['title']",
                          },
                        ],
                        staticStyle: {
                          width: "250px",
                          "margin-right": "10px",
                          "vertical-align": "middle",
                        },
                        attrs: { placeholder: "请输入FAQ名称" },
                      }),
                    ],
                    1
                  ),
                ]
              },
            },
            {
              key: "type",
              fn: function (record) {
                return [_vm._v(" " + _vm._s(_vm.faqTypes[record.type]) + " ")]
              },
            },
            {
              key: "action",
              fn: function (record) {
                return [
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.edit(record)
                        },
                      },
                    },
                    [_vm._v("编辑")]
                  ),
                  _c(
                    "a-button",
                    {
                      attrs: { type: "link" },
                      on: {
                        click: function ($event) {
                          return _vm.del(record)
                        },
                      },
                    },
                    [_vm._v("删除")]
                  ),
                ]
              },
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "formRight" },
            [
              _c(
                "a-button",
                { attrs: { type: "primary" }, on: { click: _vm.add } },
                [_vm._v("新增")]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        "a-modal",
        {
          attrs: {
            visible: _vm.visible,
            title: _vm.title,
            destroyOnClose: "",
            maskClosable: false,
          },
          on: {
            ok: function ($event) {
              return _vm.submitForm("ruleForm")
            },
            cancel: function ($event) {
              return _vm.resetForm("ruleForm")
            },
          },
        },
        [
          _c(
            "a-form-model",
            {
              ref: "ruleForm",
              staticClass: "Firmware-version_ruleForm",
              attrs: {
                model: _vm.ruleForm,
                rules: _vm.rules,
                "label-col": { span: 7 },
                "wrapper-col": { span: 14 },
              },
            },
            [
              _c(
                "a-form-model-item",
                { attrs: { label: "问题", prop: "title" } },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入问题名称",
                      showCount: "",
                      maxlength: 64,
                    },
                    model: {
                      value: _vm.ruleForm.title,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "title", $$v)
                      },
                      expression: "ruleForm.title",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "回答", prop: "answer" } },
                [
                  _c("a-textarea", {
                    attrs: {
                      placeholder: "请输入回答名称",
                      showCount: "",
                      maxlength: 1024,
                    },
                    model: {
                      value: _vm.ruleForm.answer,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "answer", $$v)
                      },
                      expression: "ruleForm.answer",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "问题类型", prop: "type" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择问答类型" },
                      model: {
                        value: _vm.ruleForm.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "type", $$v)
                        },
                        expression: "ruleForm.type",
                      },
                    },
                    _vm._l(_vm.faqTypes, function (value, key) {
                      return _c(
                        "a-select-option",
                        { key: Number(key), attrs: { value: Number(key) } },
                        [_vm._v(" " + _vm._s(value) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-model-item",
                { attrs: { label: "语言", prop: "lang" } },
                [
                  _c(
                    "a-select",
                    {
                      attrs: { placeholder: "请选择问答语言" },
                      model: {
                        value: _vm.ruleForm.lang,
                        callback: function ($$v) {
                          _vm.$set(_vm.ruleForm, "lang", $$v)
                        },
                        expression: "ruleForm.lang",
                      },
                    },
                    _vm._l(_vm.langs, function (el) {
                      return _c(
                        "a-select-option",
                        { key: el, attrs: { value: el } },
                        [_vm._v(" " + _vm._s(el) + " ")]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }